import { render, staticRenderFns } from "./SetupRootBrands.vue?vue&type=template&id=7bfd7562&scoped=true"
import script from "./SetupRootBrands.vue?vue&type=script&lang=js"
export * from "./SetupRootBrands.vue?vue&type=script&lang=js"
import style0 from "./SetupRootBrands.vue?vue&type=style&index=0&id=7bfd7562&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd7562",
  null
  
)

export default component.exports